// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".molecule-content-block.text h1,.molecule-content-block.text h2,.molecule-content-block.text h3,.molecule-content-block.text h4,.molecule-content-block.text h5,.molecule-content-block.text h6,.molecule-content-block.text iframe,.molecule-content-block.text img,.molecule-content-block.text p,.molecule-content-block.text video{margin-bottom:1rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
